import { Cookies } from 'react-cookie'

import { ACTIVE_EXPERIMENTS_COOKIE } from './constants'

import { parseActiveExperiments } from './parse'

const cookies = new Cookies()

export function getActiveExperiments() {
    const raw = cookies.get(ACTIVE_EXPERIMENTS_COOKIE)
    return parseActiveExperiments(raw)
}
